import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { NbToastrService } from '@nebular/theme';
import { GoogleService } from '../services/google.service';

@Component({
  selector: 'de-google-map-direction',
  templateUrl: './de-google-map-direction.component.html',
  styleUrls: ['./de-google-map-direction.component.scss'],
  standalone: false
})
export class DeGoogleMapDirectionComponent {
  directions: google.maps.DirectionsResult | undefined;
  private _waypoints: { location: { lat: number, lng: number, address?: string }, stopover: boolean }[] = [];
  private _firstLoad = true;
  @Input() destination: { lat: number, lng: number, address?: string };
  @Input() origin: { lat: number, lng: number, address?: string };
  @Input() optimizeWaypoints = false;
  @Input() roundTrip = false;
  map: google.maps.Map | null = null;

  @Input() set waypoints(value: { location: { lat: number, lng: number, address?: string }, stopover: boolean }[]) {
    this._waypoints = value;
    if (this._waypoints.length > 0 && !this._firstLoad) {
      this.loadDirections();
    }
  };
  get waypoints() {
    return this._waypoints;
  }



  @ViewChild(MapInfoWindow) infoWindow: MapInfoWindow;
  mapMarker: MapMarker;
  markers: any[] = [];
  selectedMarker: any;

  @Output() onResponse: EventEmitter<google.maps.DirectionsResult> = new EventEmitter<google.maps.DirectionsResult>();

  rendererOptions: google.maps.DirectionsRendererOptions = {
    suppressMarkers: true, // Set to true to hide default markers
    // polylineOptions: { strokeColor: '#ff0000' } // Customize polyline color
  };

  private directionsService: google.maps.DirectionsService;
  constructor(private toastrService: NbToastrService, private googleService: GoogleService) {
    // the direction service does not declare in google module
  }

  ngOnInit() {

    this.googleService.load("maps").subscribe(() => {
      this.directionsService = new google.maps.DirectionsService();
      this.loadDirections();
      this._firstLoad = false;
    });
  }

  loadDirections() {
    if (this.waypoints.length > 25)
      this.toastrService.danger('', 'The number of waypoints exeed the limit of direction service');

    let orginWaypoint = [...this.waypoints];
    const request: google.maps.DirectionsRequest = {
      origin: this.origin,
      destination: this.destination,
      waypoints: this.waypoints,
      travelMode: google.maps.TravelMode.DRIVING,
      optimizeWaypoints: this.optimizeWaypoints, // Finds the shortest path by reordering waypoints
      unitSystem: google.maps.UnitSystem.IMPERIAL,

    };

    if (this.roundTrip) {
      request.waypoints.push({ location: { ...this.destination } });
      request.destination = { ...this.origin };
    }

    this.directionsService.route(request, (result, status) => {
      if (status === google.maps.DirectionsStatus.OK) {
        const routeOrgin = result.routes[0].legs[0];
        const routeDest = result.routes[0].legs[result.routes[0].legs.length - 1];

        this.markers = [
          {
            position: request.origin, label: {
              text: '0',
              color: 'white',
            }, title: routeOrgin.start_address
          },
          ...orginWaypoint.map((wp, index) => ({
            position: wp.location,
            label: {
              text: `${index + 1}`,
              color: 'white',
            },
            title: `${wp.location.address}`
          })),
          {
            position: this.destination, label: {
              text: `${orginWaypoint.length + 1}`,
              color: 'white',
            }, title: this.destination.address
          }
        ];

        this.directions = result;
        this.onResponse.emit(this.directions);
      } else {
        this.toastrService.danger('', 'Error fetching directions ' + status);
      }
    });
  }

  markerClick(mapMarker: MapMarker, marker: any) {
    this.selectedMarker = marker;
    this.infoWindow.open(mapMarker);
  }



}
